import { useMutation } from '@tanstack/react-query';

import { UpdateAdvertisementClickCountApiParams } from '../types';

import { clientAxios } from '@/shared/api';

export const useUpdateAdvertisementClickCountMutation = () => {
  return useMutation({
    mutationFn: ({ id }: UpdateAdvertisementClickCountApiParams) =>
      clientAxios.patch('/updateAdvertisementClickCountApi/', { id }),
  });
};

export default useUpdateAdvertisementClickCountMutation;
